export interface ShellAdapter {
  emit: (event: string, payload: unknown) => void;
  on: (event: string, callback: (...args: unknown[]) => void, id?: string) => void;
  off: (event: string, callback: ((...args: unknown[]) => void) | undefined, id?: string) => void;
  invoke?: (event: string, payload: unknown) => Promise<unknown>;
  context?: string;
}

export interface SyncMessage<T = unknown> {
  channel: string;
  patch: T;
  origin: string;
  timestamp: number;
}

export interface SyncRequestMessage {
  channel: string;
  origin: string;
}

export const IPC_SYNC_EVENTS = {
  BROADCAST: 'zustand:sync:broadcast',
  REQUEST: 'zustand:sync:request',
  updateEvent: (channel: string) => `zustand:sync:update:${channel}` as const,
  snapshotEvent: (channel: string) => `zustand:sync:snapshot:${channel}` as const,
  peerRequestEvent: (channel: string) => `zustand:sync:peer-request:${channel}` as const,
} as const;
